import { makeStyles } from '@material-ui/core';

const TAB_HEADER_HEIGHT_IN_PX = 48;
const HEADER_HEIGHT_IN_PX = 56;

const useStyles = makeStyles(theme => ({
    wrapper: {
        width: '100%',
        height: `calc(100% - ${HEADER_HEIGHT_IN_PX}px)`,
        paddingTop: theme.spacing(2),
        display: 'flex',
        gap: 8
    },
    container: {
        width: '100%', height: '100%',
        borderRadius: theme.spacing(2),
        transition: 'width 0.3s'
    },
    tabHeader: {
        height: TAB_HEADER_HEIGHT_IN_PX
    },
    tabIndicator: {
        backgroundColor: theme.palette.info.main
    },
    tabPanel: {
        height: `calc(100% - ${TAB_HEADER_HEIGHT_IN_PX}px)`,
        // borderTop: `1px solid ${theme.palette.almostBlack[500]}`,
        background: theme.palette.background.paper,
    },
    tabWrapper: {
      alignItems: 'flex-start'  
    },
    tabRoot: {
        paddingInline: theme.spacing(2),
        minWidth: 200,
        color: ({colors:scColors}) => scColors?.neutral || theme.palette.success.main,
        '& .MuiTypography-body1': {
            fontWeight: 'bold',
            color: ({colors:scColors}) => scColors?.neutral || theme.palette.success.main,
        },
        '&.Mui-selected': {
            color: ({colors:scColors}) => scColors?.neutral || theme.palette.info.main,
        }
    },
    tabLabelSpanContainer: {
        display: 'flex', flexDirection: 'column',
        justifyContent: 'center', alignItems: 'center', height: '100%', width: '100%',
        fontFamily: ['"DM Sans", Roboto, helvetica', '!important'],
        '& .MuiIcon-root': {
            fontSize: theme.typography.pxToRem(20)
        },
        '& .MuiTypography-body1': {
            fontSize: theme.typography.pxToRem(14),
            fontFamily: ['"DM Sans", Roboto, helvetica', '!important'],
            // letterSpacing: '1px',
            // paddingLeft: theme.spacing(3),
            // textTransform: 'uppercase',
        },
        '& .MuiTypography-body2': {
            fontSize: theme.typography.pxToRem(12),
            fontFamily: ['"DM Sans", Roboto, helvetica', '!important'],
            // letterSpacing: '1px',
            // paddingLeft: theme.spacing(3),
            // textTransform: 'uppercase',
        }
    },
    sidePanelContainer: {
        width: 460,
        minHeight: '100%',
        maxHeight: '100%',
        overflowY: 'auto',
        display: 'flex', flexShrink: 0,
        // backgroundColor: theme.palette.background.paper,
        borderRadius: theme.spacing(2),
        transition: 'width 0.3s'
    }

}));

export default useStyles;